exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.project_types_container{height:100%;width:100%}.project_types_container .project_types_body{height:calc(100% - 76px);width:100%}.project_types_container .project_types_body .project_types-nav{display:inline-block}.project_types_container .project_types_body .project_types_detail{position:relative;width:calc(100% - 256px);height:100%;display:inline-block;vertical-align:top}.project_types_container .project_types_body .project_types_detail .header-edit-wrapper{height:100%;width:100%}.project_types_container .project_types_body .project_types_empty{font-family:Open Sans,sans-serif;font-weight:600;font-size:48px;color:#9b9b9b;height:100%;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.project_types_container .project_types_body .project_types_empty__icon svg{height:128px;width:162px}.project_types_container .project_types_body .project_types_empty__text{text-align:center}.project_types_container .project_types_body .project-types-add-button{width:48px;height:48px}.project_types_container .project-types-banner{height:50px;width:100%;background:#184e78;color:#fff;text-align:center;white-space:nowrap;line-height:50px;font-family:Open Sans,sans-serif;font-size:18px;font-weight:600}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectTypesContainer/ProjectTypesContainer.scss
// module id = 1800
// module chunks = 0